var _defs, _rect, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew257({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.66,
    y: 5.24,
    width: 7.34,
    height: 5.52
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.6 8.67 8 8.67 8 5.24 15.34 5.24 13.6 8.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.91,13.31a2,2,0,0,1-.84.15,1.5,1.5,0,0,1-1.58-1.62,1.59,1.59,0,0,1,1.67-1.68,1.64,1.64,0,0,1,.76.15l-.1.33a1.62,1.62,0,0,0-.65-.13,1.19,1.19,0,0,0-1.25,1.32,1.17,1.17,0,0,0,1.23,1.29,1.71,1.71,0,0,0,.68-.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.38,12.94a1.49,1.49,0,0,0,.68.19c.54,0,.71-.34.7-.6,0-.43-.39-.61-.8-.61h-.23V11.6H14c.31,0,.69-.15.69-.52s-.15-.46-.54-.46a1.08,1.08,0,0,0-.61.2l-.11-.3a1.43,1.43,0,0,1,.8-.24c.61,0,.89.36.89.73a.78.78,0,0,1-.57.73h0a.81.81,0,0,1,.68.79c0,.5-.38.93-1.12.93a1.54,1.54,0,0,1-.8-.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew257);
export default __webpack_public_path__ + "static/media/Symbolpack_New_257.bd7abd1ec2115a80bb371ed463104078.svg";
export { ForwardRef as ReactComponent };